import './css/reset.css';
import './css/fonts.css';
import './css/style.css';
import './css/header.css';
import './css/overlay.css';
import './css/footer.css';
import './css/filters.css';
import './css/menu.css';
import './css/profiles.css';
import App from './components/App';

window.onload = () => {
	const app = new App();
	app.init();
	// window.app = app;
};
